import * as console from './console'

export default {
  console
}
